import React from "react"

function MicrodataProject({
    description = "Description",
    title = "Project Name",
    image = "Default Image",
    url = "href",
    priceRange = "Preferred Price Range"

}) {
    return (
        <div>
            <div itemType="https://schema.org/Product" itemScope>
                <meta itemProp="mpn" content="10000" />
                <meta itemProp="name" content={title} />
                <link itemProp="image" href={image} />
                <meta itemProp="description" content={description} />
                <div itemProp="offers" itemType="https://schema.org/AggregateOffer" itemScope>
                    <meta itemProp="lowPrice" content={priceRange ?? 900000} />
                    <meta itemProp="highPrice" content={priceRange ?? 900000} />
                    <meta itemProp="offerCount" content="10" />
                    <meta itemProp="priceCurrency" content="IDR" />
                </div>
                <div itemProp="review" itemType="https://schema.org/Review" itemScope>
                    <div itemProp="author" itemType="https://schema.org/Person" itemScope>
                        <meta itemProp="name" content={title} />
                    </div>
                    <div itemProp="reviewRating" itemType="https://schema.org/Rating" itemScope>
                        <meta itemProp="ratingValue" content="4.5" />
                        <meta itemProp="bestRating" content="5" />
                    </div>
                </div>
                <meta itemProp="sku" content="0446310787" />
                <div itemProp="brand" itemType="https://schema.org/Brand" itemScope>
                    <meta itemProp="name" content="Duta Pertiwi" />
                </div>
            </div>
        </div>
    )
}

export default MicrodataProject